// extracted by mini-css-extract-plugin
export default {"project-info":"ProjectItem_project-info__NRf5B","name":"ProjectItem_name__PA0jf","project-heading":"ProjectItem_project-heading__OZjOY"};